import React, { useEffect, useState } from 'react';
export function CountdownTimer({
  initialMinutes = 15,
  initialSeconds = 42
}) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60 + initialSeconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const intervalId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <span className="font-mono font-bold bg-patriot-bgAlt text-patriot-red px-4 py-1.5 rounded-full mx-2 border border-patriot-red/30 shadow-[0_0_15px_rgba(229,57,70,0.5)] tracking-wider" data-id="element-6">
      {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
    </span>;
}